import { styled } from "@linaria/react";
import type { ReactNode } from "react";
import React from "react";
import { color, fonts } from "../..";
import TooltipV2 from "../../TooltipV2";
import OverlayWrapper from "../../TooltipV2/OverlayWrapper";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Label = styled.span`
  font: ${fonts.body2SemiBold};
  margin-left: 8px;
  color: ${color.carbon800};
`;

interface P {
  description?: string;
  children: ReactNode;
  name: string;
}

const Marker = ({ description, children, name }: P) =>
  description ? (
    <TooltipV2 placement="top" overlay={<OverlayWrapper text={description} />}>
      <Wrapper>
        {children}
        <Label>{name}</Label>
      </Wrapper>
    </TooltipV2>
  ) : (
    <Wrapper>
      {children}
      <Label>{name}</Label>
    </Wrapper>
  );

export default React.memo(Marker);
